module.exports = __webpack_public_path__ + "media/images/weather/34_day_g-5d706ced029b7515b08c4d1ed2bc0c54.png";